import {
	ADD_TO_FAVOURITE,
	GET_SEARCH_RESULT,
	IS_EDIT_PRESENTATION,
	IS_FOCUS_ON_MODAL_CLOSE,
	IS_TECHPACK_OPEN,
	REMOVE_SEARCH_RESULT,
	SELECTED_SEARCH_TYPE,
	UPDATE_SAMPLE_ID,
	UPDATED_ARCHIVED_PRODUCT_ID,
	VIEW_TECHPACK
} from '@store/searchOptions/action-types';

export const toggleFavourite = (isAddToFavourite) => (dispatch) => {
	dispatch({
		type: ADD_TO_FAVOURITE,
		payload: isAddToFavourite
	});
};

export const toggleViewTechpack = (isOpenTechPack) => (dispatch) => {
	dispatch({
		type: VIEW_TECHPACK,
		payload: isOpenTechPack
	});
};

export const toggleSampleId = (isEdit) => (dispatch) => {
	dispatch({
		type: UPDATE_SAMPLE_ID,
		payload: isEdit
	});
};

export const getSearchResult = (result) => (dispatch) => {
	dispatch({
		type: GET_SEARCH_RESULT,
		payload: result
	});
};

export const getSelectedSearchType = (value) => (dispatch) => {
	dispatch({
		type: SELECTED_SEARCH_TYPE,
		payload: value
	});
};

export const removeSearchResult = (value) => (dispatch) => {
	dispatch({
		type: REMOVE_SEARCH_RESULT,
		payload: value
	});
};

export const toggleModalClose = (value) => (dispatch) => {
	dispatch({
		type: IS_FOCUS_ON_MODAL_CLOSE,
		payload: value
	});
};

export const toggleEditPresentation = (value) => (dispatch) => {
	dispatch({
		type: IS_EDIT_PRESENTATION,
		payload: value
	});
};

export const setIsTechpackOpen = (value) => (dispatch) => {
	dispatch({
		type: IS_TECHPACK_OPEN,
		payload: value
	});
};

export const setUpdatedArchivedProductId = (value) => (dispatch) => {
	dispatch({
		type: UPDATED_ARCHIVED_PRODUCT_ID,
		payload: value
	});
};
